import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadGtag } from '../../utils/gtag';
import { GA_TRACKING_ID } from '../../utils/constants';

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 if ID is present
    if (GA_TRACKING_ID) {
      loadGtag(GA_TRACKING_ID);
    }

    // Send page view if GA is initialized
    if ((window as any).gtag && GA_TRACKING_ID) {
      // For GA4 SPA, we update the config with the new page path
      (window as any).gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]);

  return null;
};
